var _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgOrganDonorCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 62,
    viewBox: "0 0 100 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 97,
    height: 58,
    rx: 4,
    fill: "#FFEADB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 57,
    rx: 4,
    fill: "#EFD1B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H92C94.2091 0 96 1.79086 96 4V34H0V4Z",
    fill: "#D7AE88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H48V11H0V4Z",
    fill: "#E62645"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 38,
    width: 63,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 50,
    width: 36,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 33,
    height: 3,
    rx: 1.5,
    fill: "#FFEFF0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 44,
    width: 69,
    height: 3,
    rx: 1.5,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOrganDonorCard);
export default __webpack_public_path__ + "static/media/imgOrganDonorCard.8b3b47c74bbe1290691b5561211935cc.svg";
export { ForwardRef as ReactComponent };